module.exports = __webpack_public_path__ + "media/4.b0099e30.mp3";